export const PATH_ICONS = `icons/`;
export const PATH_IMAGES = `images/`;
export const PATH_IMAGES_SVG = `${PATH_IMAGES}svg/`;
